import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    UPDATE_BUSINESS_UPLOAD_CPD_WITHOUT_APPROVAL: (businessId, uploadCpdWithoutApproval) => ({ businessId, uploadCpdWithoutApproval }),
    API: {
      UPDATE_BUSINESS_UPLOAD_CPD_WITHOUT_APPROVAL: apiResourceActionCreator('business/uploadCpdWithoutApproval'),
    },
  },
});

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(`${API_ENDPOINT}/business/uploadCpdWithoutApproval`, authToken, payload, actions.admin.api.updateBusinessUploadCpdWithoutApproval);

function* updateBusinessUploadCpdWithoutApproval(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
};

const configuration = {
  name: 'updateBusinessUploadCpdWithoutApproval',
  action: actions,
  sagas: updateBusinessUploadCpdWithoutApproval,
  reducers: {
    request: (state, action) => ({
      ...state,
      isUpdatingBusinessUploadCpdWithoutApproval: true,
      error: null,
    }),
    success: (state, action) => ({
      ...state,
      isUpdatingBusinessUploadCpdWithoutApproval: false,
      error: null,
    }),
    failed: (state, action) => ({
      ...state,
      isUpdatingBusinessUploadCpdWithoutApproval: false,
      error: action.payload.error,
    }),
  },
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/updateBusinessUploadCpdWithoutApproval.js